import { AnalyticsEventName } from '../../../enum';
import { OrderData } from '../../order';
import { AddToWishlistEvent } from './AddToWishlist.event';
import { GTMTicketItemFactory } from '../../../factory';
import { DateTimeUtil } from '../../../../date-time';

export function mapToWishlistPayloadFromOrder(data: OrderData): AddToWishlistEvent {
    return {
        event: AnalyticsEventName.AddToWishlist,
        days_to_concert: DateTimeUtil.getDaysDifference(new Date(data.firstEventDate * 1000).toDateString()),
        days_since_purchase: Math.abs(DateTimeUtil.getDaysDifference(data.purchaseDate)),
        ecommerce: {
            currency: data.currency,
            value: data.fullValue,
            items: data.items.map(
                (orderItem, index) => GTMTicketItemFactory.fromOrderItem(orderItem, index)
            ),
        },
    };
}
